import { useEffect } from "react";

// Lightweight per-page SEO: sets document title, meta description, canonical, OG.
export function useSEO({ title, description, path }) {
  useEffect(() => {
    const fullTitle = title ? `${title} · GurSetu` : "GurSetu — Sikh Spiritual Companion";
    document.title = fullTitle;

    const setMeta = (selector, attr, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [a, v] = selector.replace(/meta\[|\]/g, "").split("=");
        el.setAttribute(a, v.replace(/["']/g, ""));
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    if (description) {
      setMeta('meta[name="description"]', "content", description);
      setMeta('meta[property="og:description"]', "content", description);
    }
    setMeta('meta[property="og:title"]', "content", fullTitle);

    const canonicalHref = `${window.location.origin}${path || window.location.pathname}`;
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonicalHref);
    setMeta('meta[property="og:url"]', "content", canonicalHref);
  }, [title, description, path]);
}
